import { render } from "./ToastNavigation.vue?vue&type=template&id=18fcff80"
import script from "./ToastNavigation.vue?vue&type=script&lang=js"
export * from "./ToastNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__